var _circle, _circle2, _circle3, _circle4, _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#e2f1ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 21,
    stroke: "#e2f1ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 13,
    r: 5.5,
    stroke: "#e2f1ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 37,
    r: 5.5,
    stroke: "#e2f1ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 25C18.5 28.0376 16.0376 30.5 13 30.5C9.96243 30.5 7.5 28.0376 7.5 25C7.5 21.9624 9.96243 19.5 13 19.5C16.0376 19.5 18.5 21.9624 18.5 25Z",
    stroke: "#e2f1ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 25C42.5 28.0376 40.0376 30.5 37 30.5C33.9624 30.5 31.5 28.0376 31.5 25C31.5 21.9624 33.9624 19.5 37 19.5C40.0376 19.5 42.5 21.9624 42.5 25Z",
    stroke: "#e2f1ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 49,
    width: 25,
    height: 3,
    fill: "#e2f1ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/miniLogo.8a86e8cec979b45da9d5d49f0b55689c.svg";
export { ForwardRef as ReactComponent };